import { type CarrierDef } from '../common.js'

const credentialTypes = ['subscription-key'] as const

export type slcyCredType = (typeof credentialTypes)[number]
export const slcy: CarrierDef<slcyCredType> = {
  name: 'Schneider Logistics',
  scac: 'slcy',
  credentialTypes,
  engineLayers: ['tracking'],
}
